// extracted by mini-css-extract-plugin
module.exports = {"input":"add-rule_input_1kyMB","inputContainer":"add-rule_inputContainer_1G1fM","appModal":"add-rule_appModal_1qxCk","button":"add-rule_button_2VFTi"};